import Vue from 'vue';
import Vuex from 'vuex';
import * as getters from './getters';
import * as actions from './actions';
import * as mutations from './mutations';
import createLogger from 'vuex/dist/logger';

Vue.use(Vuex);

const state = {
	toggledMoment: null,
	lightboxImage: '',
};

export default new Vuex.Store({
	state,
	getters,
	actions,
	mutations,
	plugins: process.env.NODE_ENV !== 'production' ? [createLogger()] : [],
});



// WEBPACK FOOTER //
// ./src/store/index.js